/** JS weekday: 0 Sunday … 6 Saturday. Sunday is always a week off. */
export const DEFAULT_WEEK_OFF_DAYS = [0] as const;

export const WEEK_OFF_OPTIONS: { day: number; label: string; locked?: boolean }[] = [
  { day: 0, label: "Sun", locked: true },
  { day: 1, label: "Mon" },
  { day: 2, label: "Tue" },
  { day: 3, label: "Wed" },
  { day: 4, label: "Thu" },
  { day: 5, label: "Fri" },
  { day: 6, label: "Sat" },
];

export function normalizeWeekOffDays(raw?: unknown): number[] {
  const set = new Set<number>();
  if (Array.isArray(raw)) {
    for (const value of raw) {
      const n = Number(value);
      if (Number.isInteger(n) && n >= 0 && n <= 6) set.add(n);
    }
  }
  set.add(0);
  return [...set].sort((a, b) => a - b);
}

export function isWeekOffDate(iso: string, weekOffDays?: unknown) {
  const days = normalizeWeekOffDays(weekOffDays);
  const [y, m, d] = iso.split("-").map(Number);
  const dow = new Date(y, m - 1, d).getDay();
  return days.includes(dow);
}
